import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import HtmlRegion from '../../../components/htmlRegion';

class Footer extends PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };

    render() {
        return (
            <div className={styles.footer}>
                <Chip id="30022" type="static" title="footer" groupName="footer" content={this.props.content}>
                    <HtmlRegion className={styles.footer2} />
                </Chip>
            </div>
        );
    }
}

export default Footer;
